import { AxiosError } from 'axios';

export const shouldRetryRequest = (failureCount: number, error: unknown) => {
  if (error instanceof AxiosError) {
    if (error.response?.status && error.response.status < 500) {
      return false;
    }
  }
  return failureCount < 3;
};
